/**
 * Popover for action button on editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Label, InputArea, TextArea } from 'wix-style-react'
// import TextIcon from 'react-icons/lib/fa/font'
// import StyleIcon from 'react-icons/lib/fa/paint-brush'

import PopoverHeader from './PopoverHeader'
// import CustomTabs from './CustomTabs'
import CustomCSSView from './customCSS/CustomCSSView'
import { setCustomFieldArray } from 'controllers/logic'

const Container = styled.div`
  _height: 26em;
  width: 20em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const TextInputContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`

class TextPopover extends Component {

  constructor () {
    super()

    this.state = {
      activeTab: 1
    }
  }

  componentWillMount () {
    this.props.updatePosition('15%', '57%')
  }

  onItemClick = (item) => this.setState({ activeTab: item.id })

  onInputChange = (e) => {
    const { value } = e.target
    const { app, dispatch, path } = this.props
    if (path) {
      dispatch(setCustomFieldArray(app.id, path, value))
    }
  }

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }

  renderEditText () {
    return (
      <TextInputContainer>
        <TextArea>
          <Label appearance='T1.1' for='firstName'>
            Edit Text
          </Label>
          <InputArea
            id='firstName'
            maxHeight='80px'
            maxLength={240}
            minHeight='40px'
            placeholder={this.props.buttonText}
            value={this.props.buttonText}
            rows={2}
            theme='normal'
            onChange={this.onInputChange}
          />
        </TextArea>
      </TextInputContainer>
    )
  }

  renderContent () {
    switch (this.state.activeTab) {
      case 0:
        return this.renderEditText()
      case 1:
        return this.renderEditCSS()
      default:
        return null
    }
  }

  render () {
    const { app, field, title, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          title={title}
          onClose={closeMyself}
          helpTooltip={'Input a text for the field'}
          app={app}
          field={field}
        />
        <Content>
          {/*<CustomTabs*/}
          {/*activeTab={this.state.activeTab}*/}
          {/*onClick={this.onItemClick}*/}
          {/*tabsInfo={[{icon: TextIcon, name: 'Text'}, {icon: StyleIcon, name: 'Style'}]}*/}
          {/*/>*/}
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

TextPopover.propTypes = {
  closeMyself: PropTypes.func,
  buttonText: PropTypes.string,
  path: PropTypes.array,
  title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
}

export default connect()(TextPopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/ActionButtonPopover.js